const toBase64Url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

// 32 random bytes encode to 43 characters, the shortest code verifier RFC 7636 allows.
export const createRandomToken = (): string =>
  toBase64Url(crypto.getRandomValues(new Uint8Array(32)));

export const createCodeChallenge = async (verifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    Uint8Array.from(verifier, (char) => char.charCodeAt(0))
  );
  return toBase64Url(new Uint8Array(digest));
};
